import React, { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import CountUp from "react-countup";

export default function Statistics() {
    const { t } = useTranslation();
    const [isVisible, setIsVisible] = useState(false);
    const sectionRef = useRef(null);

    useEffect(() => {
        const currentSection = sectionRef.current;

        const observer = new IntersectionObserver(
            ([entry]) => {
                if (entry.isIntersecting) {
                    setIsVisible(true);
                    observer.disconnect(); 
                }
            },
            { threshold: 0.3 }
        );

        if (currentSection) {
            observer.observe(currentSection);
        }

        return () => {
            if (currentSection) {
                observer.unobserve(currentSection);
            }
        };
    }, []);

    return (
        <section ref={sectionRef} className="py-[40px] bg-[#09778E]">
            <div className="container flex flex-wrap justify-between items-center">
                <div className="flex items-center justify-center flex-col text-center text-white">
                    <div className="font-bold text-[35px]">
                        {isVisible ? <CountUp end={500} duration={6} suffix="+" /> : "500+"}
                    </div>
                    <div className="capitalize">{t("Online Courses")}</div>
                </div>

                <div className="flex items-center justify-center flex-col text-center text-white">
                    <div className="font-bold text-[35px]">
                        {isVisible ? <CountUp end={2000} duration={6} suffix="+" /> : "2000+"}
                    </div>
                    <div className="capitalize">{t("Students")}</div>
                </div>

                <div className="flex items-center justify-center flex-col text-center text-white">
                    <div className="font-bold text-[35px]">
                        {isVisible ? <CountUp end={20} duration={6} suffix="+" /> : "20+"}
                    </div>
                    <div className="capitalize">{t("Instructors")}</div>
                </div>

                <div className="flex items-center justify-center flex-col text-center text-white">
                    <div className="font-bold text-[35px]">
                        {isVisible ? <CountUp end={24} duration={6} suffix="+" /> : "24+"}
                    </div>
                    <div className="capitalize">{t("Hours Support")}</div>
                </div>

                <div className="flex items-center justify-center flex-col text-center text-white">
                    <div className="font-bold text-[35px]">
                        {isVisible ? <CountUp end={200} duration={6} suffix="+" /> : "200+"}
                    </div>
                    <div className="capitalize">{t("Exams")}</div>
                </div>
            </div>
        </section>
    );
}
